import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'common/spinner/components/spinner';
import qs from 'query-string';
import { withRouter } from 'utils/withRouter';
import NotFoundErrorPage from './not-found-error-page';
import MultipleSelectionPage from './multiple-selection-page';
import { cacheSelectedServiceCenter } from '../../utils/service-center';

const DirectRoutesHandler = ({
  isLoading,
  redirectInfo,
  getRedirectInfoRequest,
  activeServiceCenterId,
  setActiveServiceCenter,
  history,
  match,
}) => {
  useEffect(() => {
    getRedirectInfoRequest({
      type: match.params.type,
      queryString: location.search || '',
    });
  }, []);

  const redirect = () => {
    history.push(`/${redirectInfo.redirectUri}/dashboard`, {
      context: redirectInfo.data[0]?.contextId || redirectInfo.data[0]?.id,
    });
  };

  useEffect(() => {
    if (redirectInfo.destination === 'redirect') {
      // Check servicecenter
      if (redirectInfo?.data[0]?.serviceCenterId !== activeServiceCenterId) {
        const result = cacheSelectedServiceCenter(redirectInfo?.data[0]?.serviceCenterId);
        setActiveServiceCenter(result);
      }
      redirect();
    }
  }, [redirectInfo]);


  if (isLoading) {
    return <Spinner />;
  }

  if (!redirectInfo) {
    return null;
  }

  if (redirectInfo?.destination === 'notfound') {
    const qparams = qs.parse(location.search);
    const entries = Object.entries(qparams);
    const searchValue = entries.reduce((result, [key, value]) =>
      `${result ? `${result}, ` : ''}${key} “${value}”`, '');

    return <NotFoundErrorPage
      type={match.params.type}
      value={searchValue.replace(/,([^,]*)$/, ' and $1')} // Find an replace last comma with and
      referenceId={redirectInfo.referenceId}
    />;
  } else if (redirectInfo?.destination === 'select') {
    const qparams = qs.parse(location.search);
    const entries = Object.entries(qparams);
    const searchValue = entries.reduce((result, [key, value]) =>
      `${result ? `${result}, ` : ''}${key} “${value}”`, '');

    return <MultipleSelectionPage
      type={match.params.type}
      value={searchValue.replace(/,([^,]*)$/, ' and $1')} // Find an replace last comma with and
      data={redirectInfo?.data}
      referenceId={redirectInfo.referenceId}
      activeServiceCenterId={activeServiceCenterId}
      setActiveServiceCenter={setActiveServiceCenter}
      contextId={redirectInfo?.contextId}
    />;
  }

  return null;
};
DirectRoutesHandler.propTypes = {
  isLoading: PropTypes.bool,
  redirectInfo: PropTypes.object,
  getRedirectInfoRequest: PropTypes.func,
  setActiveServiceCenter: PropTypes.func,
  activeServiceCenterId: PropTypes.string,
  match: PropTypes.object,
  history: PropTypes.object,
};

export default withRouter(DirectRoutesHandler);
